module.exports = __webpack_public_path__ + "static/img/banner.c6596bd8.png";